import React from "react";
import styled from "styled-components";
import Tooltip from "../tooltip/Tooltip";

const DeleteButton = ({tooltipDirection = "bottom", setOpenDeleteModal}) => {

    const handleModal = () => {
        setOpenDeleteModal(true)
    }

    return (
        <Tooltip content={"Supprimer"} direction={tooltipDirection}>
            <Button onClick={handleModal} className={"delete-btn"} id={"delete-btn"}>
                <svg id={"delete-btn"} xmlns="http://www.w3.org/2000/svg" height="24px"
                     viewBox="0 0 24 24" width="24px" fill="#E9405B">
                    <path id={"delete-btn"} d="M0 0h24v24H0V0z" fill="none"/>
                    <path id={"delete-btn"}
                          d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"/>
                </svg>
            </Button>
        </Tooltip>
    )
}

export default DeleteButton;

const Button = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 2px;
  width: 36px;
  height: 36px;
  border-radius: 50%;

  &:hover {
    background: var(--color-red);

    svg {
      fill: var(--color-white);
    }
  }

`